import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TimeAgo from 'react-timeago';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';

import ActionButtonFactory from './ActionButtons/ActionButtonFactory';

const ONE_HOUR = 60 * 60 * 1000; /* ms */

class OrderDetails extends Component {
  constructor(props) {
    super(props);

    this.statusChangeSuccess = this.statusChangeSuccess.bind(this);
    this.statusChangeError = this.statusChangeError.bind(this);
  }

  statusChangeSuccess(order, defaultRoute) {
    const { history, location } = this.props;
    const currentPath = location.pathname;
    const route = defaultRoute || `/orders/${order.id}`;
    if (route === currentPath) {
      window.location.reload();
    } else {
      history.push(route);
    }
  }

  statusChangeError(order) {
    const { notificationSystem } = this.props.refs();
    notificationSystem.addNotification({
      message: `Order #${order.orderNumber} could not be updated`,
      level: 'error',
      position: 'bc'
    });
  }

  buildOpenStatusData(order) {
    const timingUrgency = (timeDelta) => {
      const isThirtyMinutesOld = timeDelta <= ONE_HOUR / 2;
      const isOneHourOld = timeDelta <= ONE_HOUR;

      if (isThirtyMinutesOld) {
        return 'open-urgency0';
      } else if (isOneHourOld) {
        return 'open-urgency1';
      }
      return 'open-urgency2';
    };

    if (order.status === 'todo') {
      const timeDelta = (new Date()) - new Date(order.expectedFulfillDate);
      return {
        timeAgoLabel: (<TimeAgo date={order.expectedFulfillDate} />),
        statusText: 'Ordered',
        statusClassName: timingUrgency(timeDelta),
      };
    } else if (order.status === 'in progress') {
      const timeDelta = (new Date()) - new Date(order.startedAt);
      return {
        timeAgoLabel: (<TimeAgo date={order.startedAt} />),
        statusText: 'Fulfilling',
        statusClassName: `fufilling ${timingUrgency(timeDelta)}`,
      };
    }
    // generic status return
    return {
      timeAgoLabel: (<TimeAgo date={order.createdAt} />),
      statusText: 'Unknown state created',
      statusClassName: 'canceled',
    };
  }

  buildFulfilledStatusData(order) {
    const duration = Math.round(moment(order.fulfilledAt).diff(moment(order.createdAt), 'minutes', true));
    return {
      statusText: 'Fulfilled',
      statusClassName: 'fulfilled',
      timeAgoLabel: `in about ${duration} minutes`,
    };
  }

  buildClosedStatusData(order) {
    const duration = Math.round(moment(order.closedAt).diff(moment(order.createdAt), 'minutes', true));
    return {
      statusText: order.invoiceNumber ? 'Invoiced' : 'Closed',
      statusClassName: order.invoiceNumber ? 'invoiced' : 'closed',
      timeAgoLabel: `in about ${duration} minutes`,
    };
  }

  buildCanceledStatusData(order) {
    return {
      statusText: 'Cancelled',
      statusClassName: 'canceled',
      timeAgoLabel: (<TimeAgo date={order.canceledAt} />),
    };
  }

  renderStatus(order) {
    let statusData = {};
    switch (order.status) {
      case 'todo':
      case 'in progress':
        statusData = this.buildOpenStatusData(order);
        break;
      case 'fulfilled':
        statusData = this.buildFulfilledStatusData(order);
        break;
      case 'closed':
        statusData = this.buildClosedStatusData(order);
        break;
      case 'canceled':
        statusData = this.buildCanceledStatusData(order);
        break;
      default:
        // This builds a generic unknown order status
        statusData = this.buildOpenStatusData(order);
        break;
    }

    return (
      <div className="status">
        <span className={statusData.statusClassName}>
          <summary>{statusData.statusText} {statusData.timeAgoLabel}</summary>
        </span>
      </div>
    );
  }

  renderSummary(order) {
    let summary = '';

    // Open summary
    const location = order.location ? order.location : 'N/A';
    const fuelType = order.fuelOrders.length > 0 ? order.fuelOrders[0].fuelType.name : 'N/A';

    // Fulfilled summary
    const fuelTotal = order.fuelOrders.length > 0 ? `${order.fuelOrders[0].totalQuantityAdded} Gal` : 'N/A';

    // Closed summary
    const invoiceNumber = order.invoiceNumber ? order.invoiceNumber : 'N/A';

    switch (order.status) {
      case 'todo':
      case 'in progress':
        summary = `${fuelType} - ${location}`;
        break;
      case 'fulfilled':
        summary = `${fuelType} - ${fuelTotal}`;
        break;
      case 'closed':
        summary = `${fuelTotal} - ${invoiceNumber}`;
        break;
      case 'canceled':
        summary = 'N/A';
        break;
      default:
        // This builds a generic unknown order status
        summary = 'N/A';
        break;
    }

    return summary;
  }

  render() {
    return (
      <article key={this.props.order.orderNumber} className="order-item">
        <div className="order-id">
          <Link to={{ pathname: `/orders/${this.props.order.id}`, state: { orderId: this.props.order.id }}}>
            #{this.props.order.orderNumber}
          </Link>
        </div>
        <div className="customer-name">{this.props.order.customerName ? this.props.order.customerName : 'N/A'}</div>
        <div className="tail-number">{this.props.order.tailNumber ? this.props.order.tailNumber : 'N/A'}</div>
        <div className="summary">{this.renderSummary(this.props.order)}</div>
        {this.renderStatus(this.props.order)}
        {ActionButtonFactory.build(this.props.fboId, this.props.order, this.statusChangeSuccess, this.statusChangeError)}
        <div className="clear" />
      </article>
    );
  }
}

OrderDetails.propTypes = {
  fboId: PropTypes.number.isRequired,
  order: PropTypes.shape({}).isRequired,
  refs: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default OrderDetails;



// WEBPACK FOOTER //
// ./src/Containers/Orders/OrderDetails.js